"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/es/promise");

var _TraceEvent = _interopRequireDefault(require("./TraceEvent"));

var _RequestCounter = _interopRequireDefault(require("./RequestCounter"));

var w = typeof window !== 'undefined' ? window : {};

var CommonLog = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param {object} params
   */
  function CommonLog(params) {
    (0, _classCallCheck2["default"])(this, CommonLog);
    this.updateConfiguration(params);
    this.RequestCounter = new _RequestCounter["default"]({
      nbMaxRequestPerPeriod: Math.min(params.nbMaxRequestPerMinute || 100, 100),
      periodDurationInMs: params.periodDurationInMs || 60 * 1000
    });
    this.requestInterceptors = [];
  }
  /**
   * Update Configuration
   * @param {object} params
   */


  (0, _createClass2["default"])(CommonLog, [{
    key: "updateConfiguration",
    value: function updateConfiguration() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.contextName = params.contextName || '';
      this.niveauMinimalLogSurServeur = params.niveauMinimalLogSurServeur || 'ERROR';
      this.niveauMinimalLogSurClient = params.niveauMinimalLogSurClient || this.niveauMinimalLogSurServeur; // Référentiel des URLs de services de logs par contexte (socle, awt commun et sdc)

      this.logServicesUrls = params.logServicesUrls || {
        defaut: false
      }; // URL du service de logs utilisé dans le contexte d'exécution actuel

      this.logServiceUrl = this.logServicesUrls.defaut;
      this.logMaxSizeMessage = params.logMaxSizeMessage ? Math.min(params.logMaxSizeMessage * 1, 4000) : 200; // Un message est divisé en plusieurs sous messages pour faciliter la lecture dans les logs
      // Cette variable correspond au nombre max de sous message.

      this.nbMaxSsMessage = params.nbMaxSsMessage ? Math.min(params.nbMaxSsMessage, 10) : 10; // Si "nbFailedCallService" de traces envoyées au serveur sont tombées en erreur réseau, alors
      // aucune des traces suivantes ne sera envoyée au serveur.

      this.nbFailedCallService = params.nbFailedCallService ? Math.min(params.nbFailedCallService * 1, 20) : 2;
      this.countFailedRequest = this.countFailedRequest || 0; // Permet de déclarer les patterns (regex) de messages à ne pas tracer sur le serveur.

      this.filterMessagePatterns = params.filterMessagePatterns || [];
      this.cesure = params.cesure || "...";
      this.withCredentials = params.withCredentials;
      this.addUserAgent = params.addUserAgent;
      this.httpMethod = params.httpMethod || "POST";
      this.niveauParamName = params.niveauParamName || "an200_niveau";
      this.messageParamName = params.messageParamName || "cl200_message";
      this.addUserAgentParamName = params.addUserAgentParamName || "an200_add_useragent";
      this._params = params;
    }
    /**
     * Set Context
     * @param {string} name
     */

  }, {
    key: "setContext",
    value: function setContext(name) {
      var defaultUrl;
      name = name || this.contextName;

      switch (name) {
        case "socle":
        case "commun":
          defaultUrl = this.logServicesUrls.defaut;
          break;

        default:
          defaultUrl = this.logServicesUrls[this.logServicesUrls.sdc ? 'sdc' : 'defaut'];
          break;
      }

      this.logServiceUrl = this.logServicesUrls[name] || defaultUrl;
    }
  }, {
    key: "setRequestInterceptor",
    value: function setRequestInterceptor(interceptor) {
      this.requestInterceptors = [interceptor];
    }
  }, {
    key: "processRequestInterceptors",
    value: function () {
      var _processRequestInterceptors = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(xmlHttpRequest) {
        var i;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < this.requestInterceptors.length)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return Promise.resolve(this.requestInterceptors[i](xmlHttpRequest));

              case 4:
                i++;
                _context.next = 1;
                break;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function processRequestInterceptors(_x) {
        return _processRequestInterceptors.apply(this, arguments);
      }

      return processRequestInterceptors;
    }()
  }, {
    key: "removeInterceptors",
    value: function removeInterceptors() {
      this.requestInterceptors = [];
    }
    /**
     * Log Level
     * @param niveau
     * @param logs
     */

  }, {
    key: "log",
    value: function log(niveau, logs) {
      this.updateConfiguration(this._params);
      var traceEvent = null;

      if (typeof logs === 'string') {
        logs = [logs];
      } // Si le premier paramètre est un TraceEvent, on récupère le message et les méta données


      if (logs[0] instanceof _TraceEvent["default"]) {
        traceEvent = logs[0];
        logs[0] = traceEvent.getMessage();
      }

      if (this.countFailedRequest < this.nbFailedCallService) {
        // Log level
        if (this.logServiceUrl && this.getLevelIndex(this.niveauMinimalLogSurServeur) !== -1 && this.getLevelIndex(niveau) >= this.getLevelIndex(this.niveauMinimalLogSurServeur)) {
          // Check if we reached the limit, then we should not
          // send the log, otherwise we should add the timestamp
          // to the log counter queue
          if (this.RequestCounter.isMaxRequestsThresholdReached()) {
            return;
          }

          this.remoteCallback(niveau, logs, traceEvent);
        }
      }

      Array.prototype.unshift.call(logs, "[".concat(niveau, "]"));

      if (this.getLevelIndex(this.niveauMinimalLogSurClient) === -1 || this.getLevelIndex(niveau) < this.getLevelIndex(this.niveauMinimalLogSurClient)) {
        return; // no log client
      } // On ajoute les métaDonnées à la fin du message


      if (traceEvent) {
        Array.prototype.push.call(logs, traceEvent.getAllMetaDataAsString());
      }

      switch (niveau) {
        case this.NIVEAU.DEBUG:
          Function.prototype.apply.call(console.log, console, logs);
          break;

        case this.NIVEAU.INFO:
        case this.NIVEAU.NOTICE:
        case this.NIVEAU.AUDIT:
          Function.prototype.apply.call(console.info, console, logs);
          break;

        case this.NIVEAU.WARNING:
          Function.prototype.apply.call(console.warn, console, logs);
          break;

        case this.NIVEAU.ERROR:
          Function.prototype.apply.call(console.error, console, logs);
          break;
      }
    }
    /**
     *
     * @param niveau
     * @returns {number}
     */

  }, {
    key: "getLevelIndex",
    value: function getLevelIndex(niveau) {
      var i = 0;

      for (var niv in this.NIVEAU) {
        if (niveau && niv.toLowerCase() === niveau.toLowerCase()) {
          return i;
        }

        i++;
      }

      return -1;
    }
    /**
     * Trace type debug
     * @function debug
     */

  }, {
    key: "debug",
    value: function debug() {
      this.log(this.NIVEAU.DEBUG, arguments);
    }
    /**
     * Trace type info
     * @function info
     */

  }, {
    key: "info",
    value: function info() {
      this.log(this.NIVEAU.INFO, arguments);
    }
    /**
     * Trace type notice
     * @function notice
     */

  }, {
    key: "notice",
    value: function notice() {
      this.log(this.NIVEAU.NOTICE, arguments);
    }
    /**
     * Trace type warning
     * @function warning
     */

  }, {
    key: "warning",
    value: function warning() {
      this.log(this.NIVEAU.WARNING, arguments);
    }
    /**
     * Trace type error
     * @function error
     */

  }, {
    key: "error",
    value: function error() {
      this.log(this.NIVEAU.ERROR, arguments);
    }
    /**
     * Trace type audit
     * @function audit
     */

  }, {
    key: "audit",
    value: function audit() {
      this.log(this.NIVEAU.AUDIT, arguments);
    }
  }, {
    key: "parseJSON",
    value: function parseJSON(json) {
      var jsonResp;

      try {
        try {
          jsonResp = JSON.parse(json);
        } catch (e) {
          // Fallback IE, on mise tout sur le fait que jQuery traîne dans la page
          jsonResp = w.jQuery.parseJSON(json);
        }
      } catch (e) {
        jsonResp = {
          'commun': {
            'statut': "KO",
            'raison': "err_tech",
            "origine": "common.log"
          }
        };
      }

      return jsonResp;
    }
    /**
     *
     * @param niveau
     * @param logs
     * @param metaDonnees
     */

  }, {
    key: "remoteCallback",
    value: function remoteCallback(niveau, logs, traceEvent) {
      var encodedMessages;
      var encodeMessage;
      var message;
      var metaDonneesRequestParameters = traceEvent ? traceEvent.getAllMetaDataAsRequestParametersString() : "";
      var addUserAgent = typeof this.addUserAgent !== 'undefined' ? addUserAgent : traceEvent ? false : true;
      message = this._formatLogs(logs); // Filter message

      if (this._filterMessage(this.filterMessagePatterns, message)) {
        return; // no log server
      }

      message = this._convertToF5CompliantMessage(message);
      encodeMessage = encodeURIComponent(message); // splitText message into multiple message

      encodedMessages = this._splitMessage(encodeMessage, !!traceEvent);

      for (var index = 0, length = encodedMessages.length; index < length; index++) {
        this._sendMessage(niveau, encodedMessages[index], metaDonneesRequestParameters, addUserAgent, this._callbackAjaxSuccess, this._callbackAjaxError, this.logServiceUrl, this);
      }
    }
    /**
     *
     * @param response
     */

  }, {
    key: "_callbackAjaxError",
    value: function _callbackAjaxError(response) {
      this.countFailedRequest++;

      if (this.countFailedRequest >= this.nbFailedCallService) {
        console.error("".concat(this.nbFailedCallService, " log service requests on error reached, log requested disabled"));
      }
    }
    /**
     *
     * @param response
     */

  }, {
    key: "_callbackAjaxSuccess",
    value: function _callbackAjaxSuccess(response) {
      this.countFailedRequest = 0;
    }
    /**
     *
     * @param encodedMessage
     * @returns {Array}
     */

  }, {
    key: "_splitMessage",
    value: function _splitMessage(encodedMessage, hideSubMessageId) {
      var messageList = [];
      var messageOffset = 0;
      var nbSentMessages = 0; // Génération d'un identifiant commun à tous les sous messages envoyés

      var idCharacters = ['_', '+', '.', '/', '!'];
      var messageId = idCharacters[Math.floor(Math.random() * idCharacters.length)] + idCharacters[Math.floor(Math.random() * idCharacters.length)]; // Découper le message en plusieurs (max=this.nbMaxSsMessage) sous messages d'une taille inférieure à this.logMaxSizeMessage

      while (messageOffset < encodedMessage.length && nbSentMessages < this.nbMaxSsMessage) {
        // Génération d'un identifiant spécifique à chaque sous messages envoyés
        var subMessageIdPrefix = hideSubMessageId ? '' : "".concat(messageId + _pad_left('.00', nbSentMessages), " "); // Création du sous message

        var nextMessageOffset = messageOffset + (this.logMaxSizeMessage - subMessageIdPrefix.length);
        var subMessage = subMessageIdPrefix + encodedMessage.substring(messageOffset, nextMessageOffset);

        if (nextMessageOffset < encodedMessage.length) {
          // Tant que le message n'est pas complet, faire attention aux caractères encodés qui peuvent être
          // séparés dans 2 subMessages différents.
          if (subMessage.lastIndexOf('%') >= this.logMaxSizeMessage - 2) {
            // le caractère encodé est coupé entre le subMessage courant et le suivant. Reculer avant le % pour partir d'une
            // base saine
            nextMessageOffset -= this.logMaxSizeMessage - subMessage.lastIndexOf('%');
            subMessage = subMessage.substring(0, subMessage.lastIndexOf('%'));
          }

          var lastCharacterEncodedMatches = subMessage.match(/%([0-9a-zA-Z]{2})$/); // Le dernier caractère est-il encodé ?

          var needRewind = lastCharacterEncodedMatches;

          while (needRewind) {
            // On boucle jusqu'à ce que l'ensemble des membres représentant le caractère encodé se trouvent dans le subMessage
            // suivant. On ne sépare pas les membres d'une même famille.
            var lastCharacterHexaCode = lastCharacterEncodedMatches[1]; // %12 => 12

            var lastCharacterHexaCodeAsInt = parseInt(lastCharacterHexaCode, 16); // Convertir l'hexadécimal %12 en int

            if (lastCharacterHexaCodeAsInt >= 0x80
            /* binaire 1000 0000 */
            && lastCharacterHexaCodeAsInt <= 0xBF
            /* binaire 1011 1111 */
            ) {
                // Si le code numérique commençe en binaire par '10' c'est qu'il est l'un des membres représentant le caractère encodé
                // Il doit rester dans le même submessage que les autres membres
                nextMessageOffset -= 3;
                subMessage = subMessage.substring(0, subMessage.length - 3);
                lastCharacterEncodedMatches = subMessage.match(/%([0-9a-zA-Z]{2})$/) || (needRewind = false);
              } else {
              // Le code numérique correspond au premier membre représentant le caractère encodé
              nextMessageOffset -= 3;
              subMessage = subMessage.substring(0, subMessage.length - 3);
              needRewind = false;
            }
          }
        }

        messageOffset = nextMessageOffset;
        messageList.push(subMessage);
        nbSentMessages += 1;
      }

      return messageList;
    }
    /**
     *
     * @param patterns
     * @param message
     * @returns {boolean}
     */

  }, {
    key: "_filterMessage",
    value: function _filterMessage(patterns, message) {
      var regex;

      for (var index = 0, length = patterns.length; index < length; index++) {
        regex = new RegExp(patterns[index]);

        if (regex.test(message)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "_formatLogs",
    value: function _formatLogs(logs) {
      var message = [];
      var str = [];
      var msg;

      for (var index = 0, length = logs.length; index < length; index++) {
        msg = logs[index];

        switch ((0, _typeof2["default"])(msg)) {
          case "undefined":
            message.push("undefined");
            break;

          case "string":
            message.push(msg);
            break;

          case "object":
            if (msg instanceof Array) {
              message.push(msg.toString());
            } else {
              try {
                message.push(JSON.stringify(msg));
              } catch (e) {
                str = [];

                for (var attr in msg) {
                  str.push("".concat(attr, ":").concat(msg[attr]));
                }

                message.push("{".concat(str.join(','), "}"));
              }
            }

            break;

          default:
            message.push(msg.toString());
        }
      }

      return message.join('|');
    }
    /**
     * Le composant F5 bloque les messages dont le contenu peut être une menace telle qu'une injection XSS.
     * Cf. OWASP.
     *
     * @param message
     * @returns {*} message qui respecte les règles de filtrage du composant F5.
     * @private
     */

  }, {
    key: "_convertToF5CompliantMessage",
    value: function _convertToF5CompliantMessage(message) {
      var forbiddenRegexAndReplacement = [{
        regex: /script/gi,
        replacement: "s*ript"
      }, {
        regex: /settimeout/gi,
        replacement: "s*ttimeout"
      }, {
        regex: /#/gi,
        replacement: " "
      }, {
        regex: /location/gi,
        replacement: "l*cation"
      }, {
        regex: /[\u0000-\u001F\u007F]/g,
        replacement: " "
      }, // Filtrer les caractères de contrôles
      {
        regex: /<{"param/gi,
        replacement: "<*\"param"
      }, {
        regex: /<param/gi,
        replacement: "<*aram"
      }];

      for (var i = 0; i < forbiddenRegexAndReplacement.length; i++) {
        try {
          message = message.replace(forbiddenRegexAndReplacement[i].regex, forbiddenRegexAndReplacement[i].replacement);
        } catch (e) {} // Exception silencieuse pour ne pas provoquer une erreur applicative à cause d'un problème sur le logger

      }

      return message;
    }
  }, {
    key: "_sendMessage",
    value: function () {
      var _sendMessage2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(niveau, encodedMessage, metaDonneesRequestParameters, addUserAgent, callbackSuccess, callbackError, url, ctx) {
        var async, xmlHttpRequest, queryString;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                async = true;
                this.RequestCounter.incrementRequestCount(); // code for IE7+, Firefox, Chrome, Opera, Safari

                xmlHttpRequest = new XMLHttpRequest();

                xmlHttpRequest.onreadystatechange = function () {
                  if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
                    var jsonResp = ctx.parseJSON(xmlHttpRequest.responseText);

                    if (jsonResp && jsonResp.commun && jsonResp.commun.statut && jsonResp.commun.statut.toLowerCase() === "ok") {
                      callbackSuccess.call(ctx, xmlHttpRequest.responseText);
                    } else {
                      callbackError.call(ctx, xmlHttpRequest.responseText);
                    }
                  }

                  if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status !== 200) {
                    callbackError.call(ctx, xmlHttpRequest.responseText);
                  }
                };

                if (this.withCredentials) {
                  xmlHttpRequest.withCredentials = true;
                }

                queryString = "".concat(encodeURIComponent(this.niveauParamName), "=").concat(encodeURIComponent(niveau), "&").concat(encodeURIComponent(this.messageParamName), "=").concat(encodedMessage).concat(addUserAgent ? "&".concat(this.addUserAgentParamName, "=").concat(addUserAgent) : "").concat(metaDonneesRequestParameters ? "&".concat(metaDonneesRequestParameters) : "");

                if (!(this.httpMethod === 'POST')) {
                  _context2.next = 18;
                  break;
                }

                xmlHttpRequest.open('POST', url, async);
                xmlHttpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
                xmlHttpRequest.setRequestHeader("x-no-auth", "true"); // Pour des raisons d'optimisation, le header x-no-auth est ajouté à la requête pour désactiver certains contrôles SAS.

                _context2.prev = 10;
                _context2.next = 13;
                return ctx.processRequestInterceptors(xmlHttpRequest);

              case 13:
                _context2.prev = 13;
                xmlHttpRequest.send(queryString);
                return _context2.finish(13);

              case 16:
                _context2.next = 27;
                break;

              case 18:
                xmlHttpRequest.open('GET', "".concat(url, "?").concat(queryString), async);
                xmlHttpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
                xmlHttpRequest.setRequestHeader("x-no-auth", "true"); // Pour des raisons d'optimisation, le header x-no-auth est ajouté à la requête pour désactiver certains contrôles SAS.

                _context2.prev = 21;
                _context2.next = 24;
                return ctx.processRequestInterceptors(xmlHttpRequest);

              case 24:
                _context2.prev = 24;
                xmlHttpRequest.send();
                return _context2.finish(24);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10,, 13, 16], [21,, 24, 27]]);
      }));

      function _sendMessage(_x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _sendMessage2.apply(this, arguments);
      }

      return _sendMessage;
    }()
  }]);
  return CommonLog;
}();

CommonLog.prototype.TraceEvent = _TraceEvent["default"];
/**
 * Log Levels
 * @type {{AUDIT: string, NOTICE: string, ERROR: string, INFO: string, DEBUG: string, WARNING: string}}
 */

CommonLog.prototype.NIVEAU = {
  DEBUG: 'debug',
  INFO: 'info',
  NOTICE: 'notice',
  WARNING: 'warning',
  ERROR: 'error',
  AUDIT: 'audit'
};
/**
 *
 * @param pattern
 * @param str
 * @returns {string}
 * @private
 */

function _pad_left(pad, str) {
  str = "".concat(str);
  return pad.substring(0, pad.length - str.length) + str;
}
/**
 * @typedef {object} CommonLog
 * @class
 */


var _default = CommonLog;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/awt-common-log/dist/common.log.js
// module id = 91
// module chunks = 0